import { createTheme } from "@mui/material/styles";
// import Montserrat from '../montserrat/Montserrat-Medium.woff2'
// import React from "react";

const primary = getComputedStyle(document.documentElement)
  .getPropertyValue("--primary")
  .trim();
const theme = createTheme({
  palette: {
    type: "light",
    primary: {
      main: "#0d73bb",
    },
    text: {
      primary: "#333",
      secondary: "#666",
      success: "#008000",
      error: "#FF0000",
      dark: "#000",
      disabled: "#bbb",
      primaryCaption: "#0d73bb",
    },
    secondary: {
      main: "#A9A9A9",
    },
    third: {
      main: "#808080",
    },
    background: {
      default: "#FFFFFF",
    },
    sandel: {
      main: "#f6f978",
    },
    success: {
      main: "#019F4B",
    },
    textPrimary: {
      main: "#313335",
    },
    textSecondary: {
      main: "#FF5C5C",
    },
    textPromotion: {
      main: "#0d73bb",
    },
    mode: "light",
    "custom-grid-primary": { main: "#2563EB", dark: "#1E40AF" }, // cobalt blue
    "custom-grid-secondary": { main: "#14B8A6", dark: "#0F766E" }, // teal
    "custom-grid-info": { main: "#0EA5E9" },
    "custom-grid-success": { main: "#16A34A" },
    "custom-grid-warning": { main: "#F59E0B" },
    "custom-grid-error": { main: "#EF4444" },
    "custom-grid-background": { default: "#F6F7FB", paper: "#FFFFFF" },
    "custom-grid-divider": "#E6E8F0",
    "custom-grid-text": { primary: "#0F172A", secondary: "#64748B" }, // slate-900 / 500
  },
  typography: {
    // fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    // fontFamily: 'Montserrat',
    fontFamily: "Montserrat, sans-serif,Roboto",
    fontWeightBold: "400",
    label: {
      fontSize: "14px",
    },
    fontSize: 12,
    display4: {
      fontSize: 12,
    },
    display3: {
      fontSize: 12,
    },
    display2: {
      fontSize: 12,
    },
    display1: {
      fontSize: 12,
    },
    headline: {
      fontSize: 12,
    },
    title: {
      fontSize: 12,
    },
    subheading: {
      fontSize: 12,
    },
    subtitle1: {
      fontSize: "1rem",
    },
    body2: {
      fontSize: 12,
    },
    body1: {
      fontSize: 12,
    },
    h5: {
      fontSize: "12px",
    },
    h3: {
      fontSize: "16px",
    },
    p: {
      fontSize: "1rem",
    },
    caption: {
      fontSize: "0.75rem",
    },
    button: {
      fontSize: "0.75rem",
    },
    caption: {
      fontSize: 12,
      color: "#808080",
    },
    pageTitle: {
      fontSize: "18px",
      fontWeight: "bolder",
    },
  },
  components: {
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontSize: "0.9rem", // Ensure font size consistency with MuiFormLabel
          // color: 'rgba(0, 0, 0, 0.8)', // Same as above to override default rgba
          // '&.Mui-focused': {
          //   color: '#0d73bb',
          // },
          // '&.Mui-disabled': {
          //   color: 'rgba(0, 0, 0, 0.38)',
          // },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        contained: {
          textTransform: "capitalize", // 👈 ensures only first letter uppercase
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "&.Mui-disabled": {
            backgroundColor: "lightgray", // field background when disabled
            "& fieldset": {
              borderColor: "#cccccc", // border color when disabled
            },
          },
        },
        input: {
          "&.Mui-disabled": {
            WebkitTextFillColor: "#999999", // text color for disabled
            color: "#999999",
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          "&.Mui-disabled": {
            backgroundColor: "lightgray", // bg color
            color: "#999999", // text color
          },
        },
        icon: {
          "&.Mui-disabled": {
            color: "#cccccc", // dropdown arrow color
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { borderRadius: 999, fontWeight: 600 },
        outlined: { borderColor: "#CBD5E1", color: "#334155" },
      },
    },
  },
});

export default theme;
